import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["modes", "components", "tokens", "extends", "mergeClasses", "createTokenFunction", "prioritiseParentStyles"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useContext, useMemo, useEffect } from 'react';
import invariant from 'invariant';
import { mergeComponents, mergeTokens } from '../utils';
import { map } from 'lodash';
export var StylesContext = /*#__PURE__*/createContext({});
/**
 * By default, the styles provider will merge styles in a bottom up approach,
 * that is, if you have a parent set of component style overrides, and you override
 * the same component styles in a child component, the parent styles will win.
 *
 * I think the reasoning for this is that there are components in luna which
 * have component overrides, and we wanted the ability to override those styles
 * at the application level. I think the assumption may also have been that there
 * wasn't a need for multiple nested component overrides.
 *
 * Some apps have a need for nested overrides, and so we need the override
 * precidence to be top down so that a more specific style can override a global
 * one.
 *
 * We keep the default strategy as bottomUp for backwards compatibility. It also
 * means that the stylesProvider component overrides in luna apply correctly in
 * a way that can be overridden in the consuming apps.
 *
 * I think long term we should look to remove all stylesProvider component overrides.
 * Interestingly, tokens already apply top down.
 */

function applyMergeStrategy(components, parentComponents) {
  var prioritiseParentStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return prioritiseParentStyles ? mergeComponents(components, parentComponents) : mergeComponents(parentComponents, components);
}

export function StylesProvider(_ref) {
  var modes = _ref.modes,
      components = _ref.components,
      tokens = _ref.tokens,
      extendsTheme = _ref.extends,
      mergeClasses = _ref.mergeClasses,
      createTokenFunction = _ref.createTokenFunction,
      _ref$prioritiseParent = _ref.prioritiseParentStyles,
      prioritiseParentStyles = _ref$prioritiseParent === void 0 ? true : _ref$prioritiseParent,
      props = _objectWithoutProperties(_ref, _excluded);

  var parentStyles = useContext(StylesContext);
  var value = useMemo(function () {
    var _parentStyles$compone, _parentStyles$tokens;

    return {
      modes: _objectSpread(_objectSpread({}, parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.modes), modes),
      components: applyMergeStrategy(components, (_parentStyles$compone = parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.components) !== null && _parentStyles$compone !== void 0 ? _parentStyles$compone : {}, prioritiseParentStyles),
      tokens: mergeTokens(tokens, (_parentStyles$tokens = parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.tokens) !== null && _parentStyles$tokens !== void 0 ? _parentStyles$tokens : {}),
      mergeClasses: mergeClasses || (parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.mergeClasses),
      createTokenFunction: createTokenFunction || (parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.createTokenFunction)
    };
  }, [modes, components, tokens, mergeClasses, parentStyles, createTokenFunction, prioritiseParentStyles]);
  useEffect(function () {
    var _context;

    var invalidKeys = _filterInstanceProperty(_context = map(components, function (_, key) {
      return _includesInstanceProperty(key).call(key, ' ') && key;
    })).call(_context, Boolean);

    invariant(invalidKeys.length <= 0, "Path context API is deprecated. Targeting elements with \"".concat(invalidKeys.join(', '), "\" will no longer override styles of nested components. Either refactor your components to not use path context or downgrade the installed version of \"@rexlabs/styling\" to \"2.x.x\""));
  }, [components]);
  return /*#__PURE__*/React.createElement(StylesContext.Provider, _extends({}, props, {
    value: value
  }));
}